<!-- Details of failure -->
<div class="create-results large-margin lg-padding-bottom top-padding-margin-reset"
  *ngIf="requestFailed() && !isLoading()">
  <div class="title">
    <p>We had some issues adding your site(s)</p>
    <div class="icon">
      <img class="icon--main" src="{{siteImagePath}}" alt="Site image">
      <mat-icon class="icon--sub error-color">highlight_off</mat-icon>
    </div>
  </div>

  <div class="mt-4" *ngIf="returnSuccessMsgObj()">
    <div class="md-padding-bottom message-title">Successfully added site(s)</div>
    <datasource-list [type]="'success-result'" [dataSource]="returnSuccessMsgObj()">
    </datasource-list>
  </div>

  <div class="mt-4" *ngIf="returnMsgObj()">
    <div class="md-padding-bottom message-title">{{returnMsgObjTitle()}}</div>
    <datasource-list *ngIf="returnMsgObjContent().length > 0" [type]="'error-result'" [dataSource]="returnMsgObjContent()">
    </datasource-list>
  </div>

</div>

<!-- Details of success -->
<div *ngIf="!requestFailed() && !isLoading()">
  <div class="label">
    <p *ngIf="!wizardCtrl.wizardService.editMode">Your site was successfully added</p>
    <p *ngIf="wizardCtrl.wizardService.editMode">Your site was successfully updated</p>
    <div class="icon">
      <img class="icon--main" src="{{siteImagePath}}" alt="Site image">
      <mat-icon class="icon--sub success-color">check_circle_outline</mat-icon>
    </div>

  </div>
  <p class="close-text">You can now close this wizard</p>
  <div class="add-site">
    <button mat-flat-button color="primary" (click)="addAnotherSite()">
      Add another site
    </button>
  </div>
</div>

<div *ngIf="isLoading()" class="flex-centered">
  <div class="label">
    <p>Retrying</p>
  </div>
  <mat-spinner></mat-spinner>
  <div class="label medium-margin">One moment...</div>
</div>
